
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeLifeboatOutlined as ObiVesselTypeLifeboatOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-lifeboat-outlined.js';
 
 
 

 
 export const ObiVesselTypeLifeboatOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-lifeboat-outlined',
   elementClass: ObiVesselTypeLifeboatOutlinedElement,
   events: {
     
   }
  });
 
 